"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _SettingsActions = require("../actions/SettingsActions");

var _IP = _interopRequireDefault(require("../records/IP"));

var defaultState = null;

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _SettingsActions.FetchIPActionTypes.SUCCESS, function (state, action) {
  return (0, _IP.default)(action.payload.data);
}), defaultState);

exports.default = _default;
module.exports = exports.default;